/**
 * MapPage — the primary view.
 *
 * Layout:
 *   - Full-screen MapView behind everything
 *   - StoryFeed sliding panel (right)
 *   - PinDetailPanel (bottom-left, when a pin is selected)
 *   - GiveNowModal (centre overlay)
 *   - ContributorPortal (centre overlay)
 */
import MapView from '@/components/map/MapView';
import CatalystFeed from '@/components/catalyst/CatalystFeed';
import PinDetailPanel from '@/components/catalyst/PinDetailPanel';

export default function MapPage() {
  return (
    <div className="relative flex-1 overflow-hidden">
      <MapView />
      <CatalystFeed />
      <PinDetailPanel />
    </div>
  );
}
